import objectByID from './objectByID';
import { HANDLE_NEW_QDD } from '../actions/sync';
import { createSelector } from 'reselect'
import { UPDATE_SORT_INDEXES } from '../actions/question';
import { updateSortIndex } from "../sortIndex";
import { CREATE_TRANSLATION, SAVE_CAT_TRANSLATION, SAVE_Q_TRANSLATION, SAVE_TR_METADATA, FETCHED_TRANSLATION } from "../actions/translation"
import messages_spanish from "../translations/spanish.json"

const translations = (state = [], action) => {
  switch(action.type) {
    case CREATE_TRANSLATION:
      var translation = Object.assign({
        id: action.id,
        title: action.title,
        updatedAt: (new Date()).getTime(),
        questions: [],
        categories:[]
      })
      return [...state, translation];
    case SAVE_CAT_TRANSLATION:
      var translation = objectByID(state, action.trID);
      var index = state.indexOf(translation);
      return [
            ...state.slice(0, index),
            Object.assign({}, translation, {categories: action.catTrArr}, {updatedAt: (new Date()).getTime()}),
            ...state.slice(index+1)
       ];
    case SAVE_Q_TRANSLATION:
      var translation = objectByID(state, action.trID);
      var index = state.indexOf(translation);
      var question = Object.assign({}, action.props, {updatedAt: (new Date()).getTime()})
      var questionIndex = translation.questions.findIndex(q => q.engID === question.engID)
      var questions;
      //overwrite question if it already exists, otherwise add it
      if(questionIndex >= 0){
        questions = [...translation.questions.slice(0, questionIndex), question, ...translation.questions.slice(questionIndex+1)]
      } else {
        questions = [...translation.questions, question]
      }
      //to reset error
      //questions = []
      return [
        ...state.slice(0, index),
        Object.assign({}, translation, {questions: questions}, {updatedAt: (new Date()).getTime()}),
        ...state.slice(index+1)
      ];
    case SAVE_TR_METADATA:
      var translation = objectByID(state, action.trID);
      var index = state.indexOf(translation);
      return [
            ...state.slice(0, index),
            Object.assign({}, translation, {title: action.props.title, published: action.props.published, updatedAt: (new Date()).getTime()}),
            ...state.slice(index+1)
       ];
    case FETCHED_TRANSLATION:
      var translation = action.payload;
      return[...state, translation]

    default:
      return state;
  }
}

export default translations;

//load in translation files for static strings, manually set translation id in object
export const getTranslationMessages = (trID) => {
  let messages = {
    893214: messages_spanish
  }
  return(messages[trID])
}
